import BaseService from './baseService'; 



export class AccountPasswordResetService extends BaseService {
    constructor(){
        const baseUrl = "/Persons/changePassword";
        super(baseUrl);
    }  
} 